<elder-basic-pane-layout class="full py-0">
  <elder-pane class="flex-25 outlined">
    <elder-table
      class="flex"
      matSort
      [data]="scrapSpecs$ | async"
      [elderTableActivation]="{ autoActivation: 'always', autoActivateItem: 'first' }"
      [activeItem]="selectedSpec$ | async"
      (activeItemChange)="selectedSpec = $event"
      [selectionMultiEnabled]="true"
      [selectionVisible]="true"
    >
      <elder-data-toolbar
        *elderTableToolbar
        [canAdd]="true"
        [canRemove]="true"
        [canMore]="false"
        (requestNew)="addSpec()"
        (requestRemove)="onRemoveSpec($event)"
      >
      </elder-data-toolbar>

      <!-- name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'context.name' | translate }}</th>
        <td mat-cell *matCellDef="let spec">{{ spec.name }}</td>
      </ng-container>
    </elder-table>
  </elder-pane>

  <elder-pane>
    <app-scrap-spec-detail class="flex" [scrapSpec]="selectedSpec$ | async">
    </app-scrap-spec-detail>
  </elder-pane>
</elder-basic-pane-layout>
